import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../context';
import type { ChildItem } from '../types';

export function useChildren(familyId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['children', familyId],
    queryFn: () => apiClient.get<{ children: ChildItem[] }>(`/api/families/${familyId}/children`),
    enabled: !!familyId,
  });
}
